 import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Roi } from '../model/roi';
import * as DamageModel from '../model/damage.model';
import 'parse';
const parse: typeof Parse = require('parse');
import { fabric } from 'fabric_gesture';
import { iPoint } from '../model/geometry';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { environment } from '../../environments/environment';
import { TchekImageUrl } from '../model/image';
import { AwsService } from './aws.service';
import { TchekOldService } from './tchek-old.service';
import { ClassificationService } from './classification.service';
import { Subject } from 'rxjs';
import { AdminGuardService } from './admin.guard';
import { TchekType } from '../model/tchekb.model';

// Extending fabric Point class to make a new one with uid attribute
fabric.iPoint = iPoint;
export class VehiclePart {
  name: string;
  hasDirection = true;
  hasSide = true;
  isFeminine = false;

  constructor(
    partName: string,
    options?: VehiclePartOpt,
  ) {
    this.name = partName;
    if (options) {
      this.isFeminine = typeof options.isFeminine !== 'undefined' ? options.isFeminine : false;
      this.hasDirection = typeof options.hasDirection !== 'undefined' ? options.hasDirection : true;
      this.hasSide = typeof options.hasSide !== 'undefined' ? options.hasSide : true;
    }
  }

  toString() {
    return '' + this.name;
  }
}

export interface VehicleDamageType {
  [key: string]: string;
}

export interface VehicleSeverityType {
  [key: string]: string;
}

@Injectable()
export class RoiService { // TODO: should implement 'ParseAPIService<Roi>'
  private roiToEdit: Parse.Object;
  public _maskPolyOptions: any;

  public readonly severityOptionSelect = [
    {
      key: 'SEV0', value: this.i18n({
        id: 'SEV0',
        value: 'Sévérité inconnue',
        description: 'Sévérité inconnue',
        meaning: 'severity'
      })
    },
    {
      key: 'SEV1', value: this.i18n({
        id: 'SEV1',
        value: "Frottement",
        description: "Frottement",
        meaning: "severity"
      })
    },
    {
      key: 'SEV2', value: this.i18n({
        id: 'SEV2',
        value: "Réparation rapide",
        description: "Réparation rapide",
        meaning: "severity"
      })
    },
    {
      key: 'SEV3', value: this.i18n({
        id: 'SEV3',
        value: "Peinture",
        description: "Peinture",
        meaning: "severity"
      })
    },
    {
      key: 'SEV4', value: this.i18n({
        id: 'SEV4',
        value: "Tolerie peinture",
        description: "Tolerie peinture",
        meaning: "severity"
      })
    },
    {
      key: 'SEV5', value: this.i18n({
        id: 'SEV5',
        value: "Remplacement",
        description: "Remplacement",
        meaning: "severity"
      })
    }
  ];

  // TODO: refactor `parts` in an array and move trigrams in an property such as vehiclePart.key
  public readonly parts = {
    OPT: new VehiclePart(this.i18n({
      id: 'roi_OPT',
      value: "Optique",
      description: "Optique",
      meaning: "roiService"
    })),
    PHR: new VehiclePart(this.i18n({
      id: 'roi_PHR',
      value: "Phare",
      description: "Phare",
      meaning: "roiService"
    })), // ~= Optique
    PRC: new VehiclePart(this.i18n({
      id: 'roi_PRC',
      value: "Pare-choc",
      description: "Pare-choc",
      meaning: "roiService"
    }), { hasSide: false }),
    JUP: new VehiclePart(this.i18n({
      id: 'roi_JUP',
      value: "Jupe",
      description: "Jupe",
      meaning: "roiService"
    }), { hasSide: false, isFeminine: true }),
    CLR: new VehiclePart(this.i18n({
      id: 'roi_CLR',
      value: "Calandre",
      description: "Calandre",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false, isFeminine: true }),
    CLS: new VehiclePart(this.i18n({
      id: 'roi_CLS',
      value: "Calandre supérieure",
      description: "Calandre supérieure",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false, isFeminine: true }),
    CPT: new VehiclePart(this.i18n({
      id: 'roi_CPT',
      value: "Capot",
      description: "Capot",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false }),
    AIL: new VehiclePart(this.i18n({
      id: 'roi_AIL',
      value: "Aile",
      description: "Aile",
      meaning: "roiService"
    }), { isFeminine: true }),
    PRB: new VehiclePart(this.i18n({
      id: 'roi_PRB',
      value: "Pare-brise",
      description: "Pare-brise",
      meaning: "roiService"
    }), { hasSide: false }),
    ABR: new VehiclePart(this.i18n({
      id: 'roi_ABR',
      value: "Antibrouillard",
      description: "Antibrouillard",
      meaning: "roiService"
    })),
    FPS: new VehiclePart(this.i18n({
      id: 'roi_FPS',
      value: "Feu de position",
      description: "Feu de position",
      meaning: "roiService"
    })), // ~= Optique
    GRL: new VehiclePart(this.i18n({
      id: 'roi_GRL',
      value: "Grille",
      description: "Grille",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false }), // ~= Calandre
    PNE: new VehiclePart(this.i18n({
      id: 'roi_PNE',
      value: "Pneu",
      description: "Pneu",
      meaning: "roiService"
    })),
    ROU: new VehiclePart(this.i18n({
      id: 'roi_ROU',
      value: "Jante",
      description: "Jante",
      meaning: "roiService"
    }), { isFeminine: true }),
    JNT: new VehiclePart(this.i18n({
      id: 'roi_JNT',
      value: "Jante",
      description: "Jante",
      meaning: "roiService"
    }), { isFeminine: true }),
    TRP: new VehiclePart(this.i18n({
      id: 'roi_TRP',
      value: "Trappe",
      description: "Trappe",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false, isFeminine: true }), // Ouverture pour le carburant
    PRT: new VehiclePart(this.i18n({
      id: 'roi_PRT',
      value: "Porte",
      description: "Porte",
      meaning: "roiService"
    }), { isFeminine: true }),
    BGF: new VehiclePart(this.i18n({
      id: 'roi_BGF',
      value: "Baguette de flanc",
      description: "Baguette de flanc",
      meaning: "roiService"
    }), { isFeminine: true }),
    VTR: new VehiclePart(this.i18n({
      id: 'roi_VTR',
      value: "Vitre",
      description: "Vitre",
      meaning: "roiService"
    }), { isFeminine: true }),
    CST: new VehiclePart(this.i18n({
      id: 'roi_CST',
      value: "Custode",
      description: "Custode",
      meaning: "roiService"
    }), { isFeminine: true }), // Petite vitre triangulaire,
    PGN: new VehiclePart(this.i18n({
      id: 'roi_PGN',
      value: "Poignée",
      description: "Poignée",
      meaning: "roiService"
    }), { isFeminine: true }),
    GLC: new VehiclePart(this.i18n({
      id: 'roi_GLC',
      value: "Glace rétroviseur",
      description: "Glace rétroviseur",
      meaning: "roiService"
    }), { hasDirection: false, isFeminine: true }),
    RTR: new VehiclePart(this.i18n({
      id: 'roi_RTR',
      value: "Rétroviseur",
      description: "Rétroviseur",
      meaning: "roiService"
    }), { hasDirection: false }),
    COQ: new VehiclePart(this.i18n({
      id: 'roi_COQ',
      value: "Coquille rétroviseur",
      description: "Coquille rétroviseur",
      meaning: "roiService"
    }), { hasDirection: false, isFeminine: true }),
    RPT: new VehiclePart(this.i18n({
      id: 'roi_RPT',
      value: "Répétiteur",
      description: "Répétiteur",
      meaning: "roiService"
    }), { hasDirection: false }), // Clignotants latéraux
    MNP: new VehiclePart(this.i18n({
      id: 'roi_MNP',
      value: "Montant Porte",
      description: "Montant Porte",
      meaning: "roiService"
    })), // ~= Porte
    BDP: new VehiclePart(this.i18n({
      id: 'roi_BDP',
      value: "Bas de Porte",
      description: "Bas de Porte",
      meaning: "roiService"
    })), // ~= Porte
    MNT: new VehiclePart(this.i18n({
      id: 'roi_MNT',
      value: "Montant Toit",
      description: "Montant Toit",
      meaning: "roiService"
    }), { hasDirection: false }), // ~= Pavillon
    BDC: new VehiclePart(this.i18n({
      id: 'roi_BDC',
      value: "Bas de caisse",
      description: "Bas de caisse",
      meaning: "roiService"
    }), { hasDirection: false }),
    CFR: new VehiclePart(this.i18n({
      id: 'roi_CFR',
      value: "Coffre",
      description: "Coffre",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false }),
    PLI: new VehiclePart(this.i18n({
      id: 'roi_PLI',
      value: "Plaque d\'immatriculation",
      description: "Plaque d\'immatriculation",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false, isFeminine: true }),
    INS: new VehiclePart(this.i18n({
      id: 'roi_INS',
      value: "Insigne",
      description: "Insigne",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false }),
    TOI: new VehiclePart(this.i18n({
      id: 'roi_TOI',
      value: "Toit",
      description: "Toit",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false }), // ~= Pavillon
    PVN: new VehiclePart(this.i18n({
      id: 'roi_PVN',
      value: "Pavillon",
      description: "Pavillon",
      meaning: "roiService"
    }), { hasDirection: false, hasSide: false })
  };

  public readonly directions = {
    AV: this.i18n({
      id: 'roi_directions_AV',
      value: 'avant',
      description: 'avant',
      meaning: 'roiService'
    }),
    AR: this.i18n({
      id: 'roi_directions_AR',
      value: 'arrière',
      description: 'arrière',
      meaning: 'roiService'
    })
  };

  public readonly sides = parse.User.current().get('companyPtr').get("name") != "BCA_Scan" ?  {
    G: this.i18n({
      id: 'roi_sides_G',
      value: 'Côté conducteur',
      description: 'Côté conducteur',
      meaning: 'roiService'
    }),
    D: this.i18n({
      id: 'roi_sides_D',
      value: 'Côté passager',
      description: 'Côté passager',
      meaning: 'roiService'
    }),
    DF: this.i18n({
      id: 'roi_sides_DF',
      value: 'Côté passager',
      description: 'Côté passager',
      meaning: 'roiService'
    }),
    C: this.i18n({
      id: 'roi_sides_C',
      value: 'Partie centrale',
      description: 'Partie centrale',
      meaning: 'roiService'
    })
  } : {
    G: this.i18n({
      id: 'roi_sides_DF',
      value: 'Côté passager',
      description: 'Côté passager',
      meaning: 'roiService'
    }),
    D: this.i18n({
      id: 'roi_sides_G',
      value: 'Côté conducteur',
      description: 'Côté conducteur',
      meaning: 'roiService'
    }),
    DF: this.i18n({
      id: 'roi_sides_G',
      value: 'Côté conducteur',
      description: 'Côté conducteur',
      meaning: 'roiService'
    }),
    C: this.i18n({
      id: 'roi_sides_C',
      value: 'Partie centrale',
      description: 'Partie centrale',
      meaning: 'roiService'
    })
  };

  public readonly damageSizeRange =
    [
      {
        key: 'size0',
        range: [0, 5],
        value: this.i18n({
          id: 'size0',
          value: '0cm - 5cm',
          description: '0cm - 5cm',
          meaning: 'damageSize'
        })
      },
      {
        key: 'size1',
        range: [5, 10],
        value: this.i18n({
          id: 'size1',
          value: '5cm - 10cm',
          description: '5cm - 10cm',
          meaning: "damageSize"
        })
      },
      {
        key: 'size2',
        range: [10, 15],
        value: this.i18n({
          id: 'size2',
          value: '10cm - 15cm',
          description: '10cm - 15cm',
          meaning: "damageSize"
        })
      },
      {
        key: 'size3',
        range: [15],
        value: this.i18n({
          id: 'size3',
          value: 'Plus de 15cm',
          description: 'Plus de 15cm',
          meaning: "damageSize"
        })
      }
    ];

  public readonly vehicleDamageTypes = {
    bump: this.i18n({
      id: 'roi_vehicleDamageTypes_bump',
      value: 'Bosse',
      description: 'Bosse',
      meaning: 'roiService'
    }),
    added: this.i18n({
      id: 'roi_vehicleDamageTypes_added',
      value: 'Ajouté',
      description: 'Ajouté',
      meaning: 'roiService'
    }),
    scratch: this.i18n({
      id: 'roi_vehicleDamageTypes_scratch',
      value: 'Rayure',
      description: 'Rayure',
      meaning: 'roiService'
    }),
    dent: this.i18n({
      id: 'roi_vehicleDamageTypes_dent',
      value: 'Enfoncement',
      description: 'Enfoncement',
      meaning: 'roiService'
    }),
    ecl: this.i18n({
      id: 'roi_vehicleDamageTypes_ecl',
      value: 'Éclat',
      description: 'Éclat',
      meaning: 'roiService'
    }),
    imp: this.i18n({
      id: 'roi_vehicleDamageTypes_imp',
      value: 'Impact profond',
      description: 'Impact profond',
      meaning: 'roiService'
    }),
    fis: this.i18n({
      id: 'roi_vehicleDamageTypes_fis',
      value: 'Fissure',
      description: 'Fissure',
      meaning: 'roiService'
    }),
    bri: this.i18n({
      id: 'roi_vehicleDamageTypes_bri',
      value: 'Bris de glace',
      description: 'Bris de glace',
      meaning: 'roiService'
    }),
    manq: this.i18n({
      id: 'roi_vehicleDamageTypes_manq',
      value: 'Pièce manquante',
      description: 'Pièce manquante',
      meaning: 'roiService'
    }),
    col: this.i18n({
      id: 'roi_vehicleDamageTypes_col',
      value: 'Collision',
      description: 'Collision',
      meaning: 'roiService'
    }),
    def: this.i18n({
      id: 'roi_vehicleDamageTypes_def',
      value: 'Déformation',
      description: 'Déformation',
      meaning: 'roiService'
    }),
    gri: this.i18n({
      id: 'roi_vehicleDamageTypes_gri',
      value: 'Griffes',
      description: 'Griffes',
      meaning: 'roiService'
    }),
    missing_part: this.i18n({
      id: 'roi_vehicleDamageTypes_manq',
      value: 'Pièce manquante',
      description: 'Pièce manquante',
      meaning: 'roiService'
    }),
    //TODO: ADD "missing_trailer_door"
    // missing_trailer_door: this.i18n({
    //   id: 'roi_vehicleDamageTypes_manq',
    //   value: 'Pièce manquante',
    //   description: 'Pièce manquante',
    //   meaning: 'roiService'
    // }),
    broken_part: this.i18n({
      id: 'roi_vehicleDamageTypes_brok',
      value: 'Pièce cassée',
      description: 'Pièce cassée',
      meaning: 'roiService'
    }),
    other: this.i18n({
      id: 'roi_vehicleDamageTypes_other',
      value: 'Autre',
      description: 'Autre',
      meaning: 'roiService'
    }),
    multiple_impact: this.i18n({
      id: 'roi_vehicleDamageTypes_multiple_impact',
      value: 'Impact multiple',
      description: 'Impact multiple',
      meaning: 'roiService'
    }),
    broken_light: this.i18n({
      id: 'roi_vehicleDamageTypes_broken_light',
      value: 'Phare cassé',
      description: 'Phare cassé',
      meaning: 'roiService'
    }),
    opaque_light: this.i18n({
      id: 'roi_vehicleDamageTypes_opaque_light',
      value: 'Phare opaque',
      description: 'Phare opaque',
      meaning: 'roiService'
    }),
    dislocated_part: this.i18n({
      id: 'roi_vehicleDamageTypes_dislocated_part',
      value: 'Piece déboitée',
      description: 'Piece déboitée',
      meaning: 'roiService'
    }),
    parking_sensor: this.i18n({
      id: 'roi_vehicleDamageTypes_parking_sensor',
      value: 'Radar de stationnement',
      description: 'Radar de stationnement',
      meaning: 'roiService'
    }),
    washer_nozzle: this.i18n({
      id: 'roi_vehicleDamageTypes_washer_nozzle',
      value: 'Gicleur',
      description: 'Gicleur',
      meaning: 'roiService'
    }),
    missing_light: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_light',
      value: 'Phare manquant',
      description: 'Phare manquant',
      meaning: 'roiService'
    }),
    missing_hubcap: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_hubcap',
      value: 'Enjoliveur manquant',
      description: 'Enjoliveur manquant',
      meaning: 'roiService'
    }),
    missing_turn_signal: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_turn_signal',
      value: 'Clignotant manquant',
      description: 'Clignotant manquant',
      meaning: 'roiService'
    }),
    missing_bumper: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_bumper',
      value: 'Pare-choc manquant',
      description: 'Pare-choc manquant',
      meaning: 'roiService'
    }),
    missing_fuel_door: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_fuel_door',
      value: 'Trappe manquante',
      description: 'Trappe manquante',
      meaning: 'roiService'
    }),
    missing_side_molding: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_side_molding',
      value: 'Baguette de flanc manquante',
      description: 'Baguette de flanc manquante',
      meaning: 'roiService'
    }),
    missing_handle: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_handle',
      value: 'Poignée manquante',
      description: 'Poignée manquante',
      meaning: 'roiService'
    }),
    missing_mirror: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_mirror',
      value: 'Rétroviseur manquant',
      description: 'Rétroviseur manquant',
      meaning: 'roiService'
    }),
    missing_mirror_cover: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_mirror_cover',
      value: 'Coque manquante',
      description: 'Coque manquante',
      meaning: 'roiService'
    }),
    missing_mirror_glass: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_mirror_glass',
      value: 'Glace manquante',
      description: 'Glace manquante',
      meaning: 'roiService'
    }),
    missing_numberplate: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_numberplate',
      value: 'Plaque d\'immatriculation manquante',
      description: 'Plaque d\'immatriculation manquante',
      meaning: 'roiService'
    }),
    missing_badge: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_badge',
      value: 'Insigne manquant',
      description: 'Insigne manquant',
      meaning: 'roiService'
    }),
    missing_bumper_molding: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_bumper_molding',
      value: 'Bandeau-pare-choc manquant',
      description: 'Bandeau-pare-choc manquant',
      meaning: 'roiService'
    }),
    missing_grill: this.i18n({
      id: 'roi_vehicleDamageTypes_missing_grill',
      value: 'calandre manquante',
      description: 'calandre manquante',
      meaning: 'roiService'
    }),
  } as VehicleDamageType;


  public readonly vehicleSeverityTypes = {
    SEV0: this.i18n({
      id: 'SEV0',
      value: 'Sévérité inconnue',
      description: 'Sévérité inconnue',
      meaning: 'severity'
    }),
    SEV1: this.i18n({
      id: 'SEV1',
      value: "Frottement",
      description: "Frottement",
      meaning: "severity"
    }),
    SEV2: this.i18n({
      id: 'SEV2',
      value: "Réparation rapide",
      description: "Réparation rapide",
      meaning: "severity"
    }),
    SEV3: this.i18n({
      id: 'SEV3',
      value: "Peinture",
      description: "Peinture",
      meaning: "severity"
    }),
    SEV4: this.i18n({
      id: 'SEV4',
      value: "Tolerie peinture",
      description: "Tolerie peinture",
      meaning: "severity"
    }),
    SEV5: this.i18n({
      id: 'SEV5',
      value: "Remplacement",
      description: "Remplacement",
      meaning: "severity"
    })
  } as VehicleSeverityType;

  private highlightedDamage: any;
  private highlightedDamageCompare: any;

  private highlightedRoi: DamageModel.Roi;

  constructor(private readonly i18n: I18n,
	private http: HttpClient,
     private _awsService: AwsService,
    private readonly _classificationService: ClassificationService,
    private _tchekService: TchekOldService) {
    this._maskPolyOptions = {
      kind: 'mask',
      selectable: false,
      objectCaching: false,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      fill: 'deeppink',
      stroke: 'gold',
      strokeWidth: 1,
      opacity: 0.1
    };
  }

  public getPictureRois(tchek: string, folder: string, picture: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('Roi'));

      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchek
      });
      query.include(['damagePtr', 'folderPtr'])
        .notEqualTo('isProjected', true)
        .equalTo('folder', folder)
        .equalTo('picture', picture)
        .equalTo('isDeleted', false)
        .limit(2048)
        .find().then((retrievedRois) => {
          resolve(retrievedRois);
        }, (error) => {
          console.error('Could not retrieve ROIs : ', error.code, error.message);
          reject(error);
        });
    });
  }

  public getPictureRoisCount(tchek: string, folder: string, picture: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('Roi'));

      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchek
      });
      query.equalTo('folder', folder);
      query.equalTo('picture', picture);
      query.equalTo('isDeleted', false);
      query.count().then((totalRoisCount) => {
        resolve(totalRoisCount);
      }, (error) => {
        console.error('Could not count ROIs for picture ', tchek, '/', folder, '/', picture, ' : ', error.code, error.message);
        reject(error);
      });
    });
  }

  public getCameraRois(tchek: string, cameraName: string, validatedOnly?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      let query = new parse.Query(parse.Object.extend('Roi'));

      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchek
      }).include(['damagePtr', 'folderPtr'])
        .limit(1000)
        .equalTo('isDeleted', false)
        .equalTo('folder', cameraName);

      // Restrict automatic ROIs to validated only if specified
      if (validatedOnly) {
        query = parse.Query.and(query,
          parse.Query.or(
            new parse.Query(parse.Object.extend('Roi'))
              .include(['damagePtr', 'folderPtr'])
              .equalTo('isAuto', false),
            new parse.Query(parse.Object.extend('Roi'))
              .include(['damagePtr', 'folderPtr'])
              .equalTo('isAuto', true).equalTo('isValidated', true))
        );
      }
      query.find().then((retrievedRois: any) => {
        resolve(retrievedRois);
      }, (error) => {
        console.error('Could not retrieve ROIs : ', error.code, error.message);
        reject(error);
      });
    });
  }


  public parseFileObj = (url: string, name?: string):
  Parse.File => ({ url: (() => url), name: (() => name || url) } as Parse.File);
  

  public tokenMemory  = new Map<string, any>();
  public tokenReport
  public tokenReportCLIENT 
  async getToken(tchek, cost = true) {
	return new Promise<any | any>(async (resolve, reject) => {
  		let companyPtr = tchek.get('companyPtr') ? tchek.get('companyPtr'):tchek.get('devicePtr').get('companyPtr')
		if (!companyPtr) return reject()
 		
 		if (!this.tokenMemory.get(companyPtr.id) ){
			const app = parse.Object.extend("APIToken");
			let query = new parse.Query(app);
			 query.equalTo("companyPtr", companyPtr);
			let token = await query.first() 
			console.log('token      ', token );
 			this.tokenMemory.set(companyPtr.id, token)
		}
 		let key = this.tokenMemory.get(companyPtr.id).get('token')

 		let tchekId = tchek.id
	  const httpOptions = {
		headers: new HttpHeaders({
		  'Content-Type': 'application/json',
		  "X-API-Key": key
		})
	  };
	  let data = {
		"deviceId" : null,
		"validity" : null,
		"shootInspect" : false,
		"fastTrack" : false,
		"cost" : cost,
		"report" : true,
		"downloadRoi" : true,
		"tchekId" : tchekId
	}
	console.log('route', data)
 	  this.http.post<any>(environment.backAltoUrl + '/apiV1/tokenmanager/token', data, httpOptions)
		.subscribe({
		  next: dataR => {
  			resolve(dataR.token.uid)
			 if (cost )
			 this.tokenReport = dataR.token.uid
			 else
			 this.tokenReportCLIENT = dataR.token.uid
		  },
		  error: error => {
			console.log(error);
		  }
		})
	});
  }
 
 
  async getReport(tchek ) {
	return new Promise<any | any>(async (resolve, reject) => {
		let companyPtr = tchek.get('companyPtr') ? tchek.get('companyPtr'):tchek.get('devicePtr').get('companyPtr')

		if (!this.tokenMemory.get(companyPtr.id)){
			const app = parse.Object.extend("APIToken");
			let query = new parse.Query(app);
			 query.equalTo("companyPtr", companyPtr);
			let token = await query.first() 
			console.log('token      ', token );
 			this.tokenMemory.set(companyPtr.id, token)
		}
		if (this.tokenMemory.get(companyPtr.id) === undefined){ 
		reject('no token for company')
		}
 		
		let key = this.tokenMemory.get(companyPtr.id).get('token')

	  const httpOptions = {
		headers: new HttpHeaders({
		  'Content-Type': 'application/json',
		  'X-API-Key': key
 		})
	  };
 	  this.http.get<any>(environment.backAltoUrl + '/apiV1_sdk/tchek/loadTchek?tchekId=' + tchek.id,  httpOptions)
		.subscribe({
		  next: data => {
 			resolve(data)
		  },
		  error: error => {
			console.log(error);
		  }
		})
	});
  }

  public getCameraAutoRois(tchek: string, cameraName: string): Promise<Array<Parse.Object>> {
    return new Promise((resolve, reject) => {
      this.getCameraRois(tchek, cameraName).then(rois => {
        // console.log('Resolving with auto ROIs ', rois.filter(r => (r.get('isAuto'))));
        resolve(rois.filter(r => (r.get('isAuto'))));
      }, error => reject(console.error(error)));
    });
  }

  public imagesF : {tchekId :string, images : any[]}


  public async toRoiAnalysisObject(  roi: DamageModel.Roi): Promise<DamageModel.RoiAnalysis> {
    const roiWithUrls = new DamageModel.RoiAnalysis(roi);
    if (roi.imagePtr !== undefined) {
		console.log(this.imagesF);
		if ([4,5].includes(roi.tchekPtr.type)){
		 let index = this.imagesF.images.findIndex(f => { return f.id === roi.imagePtr.id})
		roi.imagePtr.file = this.parseFileObj(this.imagesF.images[index].url);
	}
      roiWithUrls.bestImageUrl = new TchekImageUrl({
        hd: roi.imagePtr.file.url(),
        mini: roi.imagePtr.file.url(),
        image: roi.imagePtr.id,
      })
    } else {
      if (!roi)
        throw new Error(`Error roi`);
      if (!roi.folderPtr)
        throw new Error(`ROI ${roi.id} has no attribute folderPtr`);
      const ipMachine = roi.tchekPtr.devicePtr.ipMachine
      const baseUrl = `${environment.isLocal ? roi.damagePtr.tchekPtr.devicePtr.webObjectId : roi.damagePtr.tchekPtr.devicePtr.id}/${roi.damagePtr.tchekPtr.path}`;
      roiWithUrls.imagesUrl.push(new TchekImageUrl({
        hd: `${baseUrl}/${roi.folder}/${roi.picture}.jpg`,
        mini: `${baseUrl}/mini/${roi.folder}/${roi.picture}.jpg`,
        camera: parseInt(roi.folder, 10),
        picture: roi.picture
      }));
      // Generating best image URL
      const cpPromises = [];
      cpPromises.push(this._awsService.generateUrlPromise(`${baseUrl}/${roi.folderPtr.name}/${roi.picture}.jpg`, ipMachine))
      cpPromises.push(this._awsService.generateUrlPromise(`${baseUrl}/mini/${roi.folderPtr.name}/${roi.picture}.jpg`, ipMachine))

      Promise.all(cpPromises).then(resolvedPromises => {
        // console.log('All promises resolutions :', resolvedPromises);
        // At this point, all media of all sizes have been loadedfolder
        roiWithUrls.bestImageUrl = new TchekImageUrl({
          hd: resolvedPromises[0],
          mini: resolvedPromises[1],
          camera: parseInt(roi.folder, 10),
          picture: roi.picture
        });

      })
    }
    //    console.log(roiWithUrls, roiWithUrls.id);
    return roiWithUrls;
  }


  public getTchekRois(tchek: string, forDamageList = false): Promise<any> {
    return new Promise((resolve, reject) => {
      let activeRoiAdminDrawer = parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") ? parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") : false;
      let query = new parse.Query(parse.Object.extend('Roi'));

      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchek
      }).include(['damagePtr', 'folderPtr', 'imagePtr', 'tchekPtr', 'tchekPtr.devicePtr'])
        .limit(10000)
      if (!activeRoiAdminDrawer)
        query.notEqualTo('isDeleted', true)
      if (forDamageList || parse.User.current().get('isSuperAdmin') !== true || environment.isLocal === false)
        query.notEqualTo('isProjected', true)
      if (this._classificationService.active) {
        query.notEqualTo('isComposed', true)
        query.doesNotExist('classificationStatus')
      } else {
        query.notEqualTo('isComposed', false)
      }
      query.exists('damagePtr')
      query.find().then(async (retrievedRois: any) => {
 let roi = retrievedRois[0]
		if (roi && [4,5].includes(roi.get('tchekPtr').get('type'))
		&&(!this.imagesF || this.imagesF.tchekId !==  roi.get('tchekPtr') .id)){
			try {
				let report = await this.getReport(roi.get('tchekPtr'))
				console.log(report);
				this.imagesF= {tchekId : roi.get('tchekPtr').id, images : report.data.images }
			} catch (error) {
				console.log(error)
			}
			}
        resolve(retrievedRois);
      }, (error) => {
        console.error('Could not retrieve ROIs : ', error.code, error.message);
        reject(error);
      });
    });
  }


  // ! Returns the Damage not the ROI saved
  public setPictureRoi(roi: Roi): Promise<any> {
    return new Promise((resolve, reject) => {
      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      this._tchekService.getTchek(roi.tchek.id)
        .then(tchek => {
          if (tchek)
            for (let [key, value] of Object.entries(tchek.getACL())) {
              for (let [k, v] of Object.entries(value)) {
                if (k.split(':')[1]) {
                  acl.setRoleReadAccess(k.split(':')[1], v.read);
                  acl.setRoleWriteAccess(k.split(':')[1], true);
                }
              }

              parse.Cloud.run('newDamage', {
                centerX: roi.centerX,
                centerY: roi.centerY,
                width: roi.width,
                height: roi.height,
                folder: roi.folder,
                tchekPtr: roi.tchek.id,
                folderId: roi.folderPtr,
                isDeleted: false,
                radius: roi.radius,
                picture: roi.picture,
                imageId: roi.imageId,
                type: roi.type,
                location: roi.location,
                comment: roi.comment,
                severity: roi.severity,
                isAuto: roi.isAuto,
                costType: roi.costType,
                cost: roi.cost,
                acl: acl,
                toSync: true
              }).then(
                function (result) {
                  resolve(result);
                },
                function (error) {

                  reject(error);
                }
              );
            }
        })
    });
  }

  // ! Returns the ROI saved
  public createNewRoi(roi: Roi, imageId, damageId): Promise<any> {
    return new Promise((resolve, reject) => {
      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      this._tchekService.getTchek(roi.tchek.id)
        .then(tchek => {
          if (tchek)
            for (let [key, value] of Object.entries(tchek.getACL())) {
              for (let [k, v] of Object.entries(value)) {
                acl.setRoleReadAccess(k.split(':')[1], v.read);
                acl.setRoleWriteAccess(k.split(':')[1], v.write);
              }

              parse.Cloud.run('newDamageRoi', {
                centerX: roi.centerX,
                centerY: roi.centerY,
                width: roi.width,
                height: roi.height,
                folder: roi.folder,
                tchekPtr: roi.tchek.id,
                folderId: roi.folderPtr,
                damageId: damageId,
                isDeleted: false,
                radius: roi.radius,
                picture: roi.picture,
                imageId: imageId,
                type: roi.type,
                location: roi.location,
                comment: roi.comment,
                severity: roi.severity,
                isAuto: roi.isAuto,
                costType: roi.costType,
                cost: roi.cost,
                acl: acl,
                toSync: true
              }).then(
                function (result) {
                  resolve(result);
                },
                function (error) {

                  reject(error);
                }
              );
            }
        })
    });
  }


  public updateRoi(roi: Parse.Object): Promise<any> {
    return new Promise((resolve, reject) => {
      roi.set('toSync', true);
      roi.save().then((savedRoi) => {
        resolve(savedRoi);
      }, (error) => {
        console.error('Failed to update new ROI, with error: ' + error.code + ' ' + error.message);
        reject(error);
      });
    });
  }

  // Deletes ParseObject ROIs or Fabric Group ROIs
  // *Does not work if argument is not an array
  public deletePictureRois(rois: Array<any>): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(rois))
        reject(console.error('RoiService.deletePictureRois(any[]) accepts only an array as a unique argument'));
      const promises = [];
      const parentPromises = [];
      for (let i = 0; i < rois.length; i++) {
        let roiId;
        console.log('damage', rois[i]);
        if (rois[i].id)
          roiId = rois[i].id;
        else
          roiId = rois[i].getObjects('circle')[0].group.parseId;

        const query = new parse.Query(parse.Object.extend('Damage'));
        const roiPtr = {
          __type: 'Pointer',
          className: 'Roi',
          objectId: roiId
        };
        query.equalTo('roiPtr', roiPtr);
        console.log('searching roi with id ', roiId);
        parentPromises.push(query.first());
      }
      // Wait for all ROIs to be found
      Promise.all(parentPromises).then((resolvedParentPromises) => {
        for (let i = 0; i < resolvedParentPromises.length; i++) {
          resolvedParentPromises[i].set('isDeleted', true);
          resolvedParentPromises[i].set('toSync', true);
          promises.push(resolvedParentPromises[i].save());
        }

        // Wait for all ROIs to be saved i.e. deleted
        Promise.all(promises).then(resolvedPromises => {
          resolve(resolvedPromises);
        }, error => {
          console.error('Could not delete ROI from Parse', error.code, error.message);
          reject(error);
        });
      }, error => {
        console.error('Could not match an ROI from Parse :', error.code, error.message);
        reject(error);
      });

    });
  }

  public deleteRoiById(id: string) {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('Roi'));
      query.equalTo('objectId', id);
      query.first().then((remoteRoi) => {
        remoteRoi.set('isDeleted', true);
        remoteRoi.set('toSync', true);
        remoteRoi.save().then((savedRoi) => {
          resolve(savedRoi);
        }, (error) => {
          console.log('Could not delete an ROI from Parse :', error.code, error.message);
          reject(error);
        });
      }, (error) => {
        console.log('Could not match an ROI from Parse with id ', id, ':', error.code, error.message);
        reject(error);
      });
    });
  }

  public deleteRoi(roi: Parse.Object) {
    return new Promise((resolve, reject) => {
      roi.set('isDeleted', true);
      roi.set('toSync', true);
      if (roi.get('imagePtr')) {
        console.log('roi has imageptr');
        roi.get('imagePtr').set('isDeleted', true);
        roi.get('imagePtr').save().then((savedImage) => {
          roi.save().then((savedRoi) => {
            resolve(savedRoi);
          }, (error) => {
            console.log('Could not delete an ROI from Parse :', error.code, error.message);
            reject(error);
          });
        }, (error) => {
          console.log('Could not delete an ROI from Parse :', error.code, error.message);
          reject(error);
        });
      } else
        roi.save().then((savedRoi) => {
          resolve(savedRoi);
        }, (error) => {
          console.log('Could not delete an ROI from Parse :', error.code, error.message);
          reject(error);
        });
    });
  }

  public setRoiToEdit(roi?: Parse.Object, setBy?: number): Parse.Object {
    this.roiToEdit = roi;
    console.log('setting roi to edit', this.roiToEdit);
    return this.roiToEdit;
  }

  public getRoiToEdit(): Parse.Object {
    // console.log('getting roi to edit', this.roiToEdit);
    return this.roiToEdit;
  }

  public groupRoisByCamera(rois: Array<any>): any {
    if (!rois || rois.length < 1)
      return console.warn('Cannot group by camera', rois);

    const knownCameras = [];
    const groupedRois = {};
    rois.forEach(r => {
      if (knownCameras.includes(r.get('folder')))
        groupedRois[r.get('folder')].push(r);
      else {
        groupedRois[r.get('folder')] = [r];
        knownCameras.push(r.get('folder'));
      }
    });
    // console.log('groupedrois', groupedRois);
    return groupedRois;
  }

  public groupDamagesByCamera(damages: Array<any>): any {
    if (!damages || damages.length < 1)
      return console.warn('Cannot group by camera', damages);

    const knownCameras = [];
    const groupedDamages = {};
    damages.forEach(d => {
      if (knownCameras.includes(d.get('roiPtr').get('folder')))
        groupedDamages[d.get('roiPtr').get('folder')].push(d);
      else {
        groupedDamages[d.get('roiPtr').get('folder')] = [d];
        knownCameras.push(d.get('roiPtr').get('folder'));
      }
    });
    // console.log('groupedDamages', groupedDamages);
    return groupedDamages;
  }
  public groupDamagesByParts(damages: Array<any>): any {
    if (!damages || damages.length < 1)
      return console.warn('Cannot group by parts');

    const knownParts = [];
    const groupedDamages = {};
    damages.forEach(d => {
      if (knownParts.includes(d.get('location')))
        groupedDamages[d.get('location')].push(d);
      else {
        groupedDamages[d.get('location')] = [d];
        knownParts.push(d.get('location'));
      }
    });
    // console.log('groupedDamages', groupedDamages);
    return groupedDamages;
  }

  public transformMaskToPoints(mask: any): Array<any> {
    if (!mask)
      return undefined;

    let points = [];
    mask.x.forEach((x, i) => {
      points.push(new fabric.iPoint(x, mask.y[i]));
    });
    return points;
  }

  public calcRelativePoints(canvasRef: any, points: Array<any>, size: { w: number, h: number }): Promise<Array<fabric.iPoint>> {
    return new Promise<fabric.iPolygon>((resolve, reject) => {
      const relativePoints = [];
      points.forEach(p => {
        relativePoints.push(new fabric.iPoint(
          p.x * canvasRef.backgroundImage.getScaledWidth() / size.w + canvasRef.backgroundImage.left,
          p.y * canvasRef.backgroundImage.getScaledHeight() / size.h + canvasRef.backgroundImage.top));
      });
      // console.log('after calc', points);
      resolve(relativePoints);
    });
  }

  public mapToSvgId(partNameFromDb: string): string {
    if (partNameFromDb === undefined ||  partNameFromDb === null ) {
      partNameFromDb = '';
    }
    partNameFromDb = partNameFromDb.trim();
    let partName = partNameFromDb.substr(0, 3);
    if (!(partName in this.parts)) {
      return 'unknow';
    }

    // console.log('Mapping ', partName, 'to', this.parts[partName]);
    let side: string, direction: string;

    if (partNameFromDb.length === 5) { // Direction only
      direction = partNameFromDb.substr(3, 2);
    } else if (partNameFromDb.length === 4) {// Side only
      side = partNameFromDb.substr(3, 1);
    } else { // Direction and side
      direction = partNameFromDb.substr(3, 2);
      side = partNameFromDb.substr(5, 1);
    }

    // Defining special conditions for parts that form a group of subparts
    if (partName === 'ROU' || partName === 'PNE')
      partName = 'JNT';
    else if (partName === 'FPS' || partName === 'PHR')
      partName = 'OPT';
    else if (partName === 'CLS')
      partName = 'CLR';
    else if (partName === 'TRP')
      return 'TRP';
    else if (partName === 'JUP')
      partName = 'PRC';

    // console.log("partName",partName)
    return partName.concat(
      this.parts[partName].hasDirection &&
        direction ? direction : '',
      this.parts[partName].hasSide &&
        side ? side : '');
  }

  /* Generates all variants of a part
  e.g. (OPT) => [OPTAVD, OPTAVG, OPTARD, OPTARG] */
  public getAllLocationPossibleVariants(locationKey: string, vehiclePart: VehiclePart): string[] {
    const variants = [];
    if (vehiclePart.hasDirection && vehiclePart.hasSide)
      variants.push(
        `${locationKey}AVD`,
        `${locationKey}AVG`,
        `${locationKey}ARD`,
        `${locationKey}ARG`
      );
    else if (vehiclePart.hasDirection)
      variants.push(
        `${locationKey}AV`,
        `${locationKey}AR`
      );
    else if (vehiclePart.hasSide)
      variants.push(
        `${locationKey}G`,
        `${locationKey}D`
      );
    else
      variants.push(locationKey);

    return variants;
  }

  public setHighlightedDamage(damage?: any) {
    this.highlightedDamage = damage;
  }

  public setHighlightedDamageCompare(damage?: any) {
    this.highlightedDamageCompare = damage;
    console.log('damage compare : ', damage);
  }


  public getHighlightedDamage(): any {
    return Object.assign({}, this.highlightedDamage);
  }

  // For the future
  public setHighlightedRoi(roi?: DamageModel.RoiAnalysis) {
    this.highlightedRoi = roi;
    this.selectRoi()
  }

  public getHighlightedRoi() {
    return this.highlightedRoi;
  }

  public isRoiHighlighted(roi: any) {
    // If no damage set, all ROIs appear at full opacity
    return !this.highlightedRoi || (this.highlightedRoi.id === roi.id);
  }


  private newRoiSelected = new Subject<any>();
  selectNewRoiObs = this.newRoiSelected.asObservable();
  selectRoi() {
    this.newRoiSelected.next()
  }

  public isDamageHighlighted(damage: any) {
    // If no damage set, all ROIs appear at full opacity
    return !this.highlightedDamage || (this.highlightedDamage.id === damage.id);
  }

  public isDamageHighlightedCompare(damage: any) {
    // If no damage set, all ROIs appear at full opacity
    // console.log(this.highlightedDamageCompare.id, damage.id);
    return !this.highlightedDamageCompare || (this.highlightedDamageCompare.id === damage.id);
  }

  public isDamageSelected(damage: any) {
    return this.highlightedDamage && (this.highlightedDamage.id === damage.id);
  }

  public async getByDamage(id: string) {
    const query = this.baseQuery();
    const damage = new parse.Object('Damage');
    damage.id = id;
    try {
      await damage.fetch();
      const roisFound = [];
      (await query.equalTo('damagePtr', damage).find())
        .forEach(r => {
          // this.store[r.id] = new Roi(r);
          // roisFound.push(this.store[r.id]);
        });
      return roisFound;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public toPicturePercent(numberPicture: number, totalPictures: number): string {
    if (!numberPicture && !totalPictures)
      return (0).toString();
    return (Math.ceil((numberPicture / totalPictures) * 100)).toString();
  }

  private baseQuery(): Parse.Query {
    return new parse.Query('Roi').include(['damagePtr', 'folderPtr']);
  }

}

export class VehiclePartOpt {
  hasDirection?: boolean;
  hasSide?: boolean;
  isFeminine?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/service/roi.service.ts